/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetCourseReportsElaPerformanceByStandardR200ResponseInnerRlStandardFromJSON, GetCourseReportsElaPerformanceByStandardR200ResponseInnerRlStandardToJSON, } from './GetCourseReportsElaPerformanceByStandardR200ResponseInnerRlStandard';
import { GetCourseReportsElaPerformanceByStandardR200ResponseInnerStatsInnerFromJSON, GetCourseReportsElaPerformanceByStandardR200ResponseInnerStatsInnerToJSON, } from './GetCourseReportsElaPerformanceByStandardR200ResponseInnerStatsInner';
/**
 * @export
 */
export const GetCourseReportsElaPerformanceByStandardR200ResponseInnerProductEnum = {
    AdaptiveSkills: 'ela-adaptive-skills',
    Reading: 'ela-reading',
    TargetedSkills: 'ela-targeted-skills',
    WordStudy: 'ela-word-study'
};
/**
 * Check if a given object implements the GetCourseReportsElaPerformanceByStandardR200ResponseInner interface.
 */
export function instanceOfGetCourseReportsElaPerformanceByStandardR200ResponseInner(value) {
    if (!('product' in value) || value['product'] === undefined)
        return false;
    if (!('rlStandard' in value) || value['rlStandard'] === undefined)
        return false;
    if (!('stats' in value) || value['stats'] === undefined)
        return false;
    return true;
}
export function GetCourseReportsElaPerformanceByStandardR200ResponseInnerFromJSON(json) {
    return GetCourseReportsElaPerformanceByStandardR200ResponseInnerFromJSONTyped(json, false);
}
export function GetCourseReportsElaPerformanceByStandardR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'product': json['product'],
        'rlStandard': GetCourseReportsElaPerformanceByStandardR200ResponseInnerRlStandardFromJSON(json['rlStandard']),
        'stats': (json['stats'].map(GetCourseReportsElaPerformanceByStandardR200ResponseInnerStatsInnerFromJSON)),
    };
}
export function GetCourseReportsElaPerformanceByStandardR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'product': value['product'],
        'rlStandard': GetCourseReportsElaPerformanceByStandardR200ResponseInnerRlStandardToJSON(value['rlStandard']),
        'stats': (value['stats'].map(GetCourseReportsElaPerformanceByStandardR200ResponseInnerStatsInnerToJSON)),
    };
}
